import React, { useState } from 'react'
import './Allergy.css'
import { RiArrowRightSLine } from 'react-icons/ri'
import Header from '../../Header/header'
import Whatsapp from '../../Whatsapp/Whatsapp'
import { Helmet } from 'react-helmet'
import ServiceDoctorInfo from '../ServiceDoctorInfo'
import doc_img2 from '../../../assets/doc_img2.webp'

const Allergy = () => {
  const [activeIndex, setActiveIndex] = useState(null)

  const faqData = [
    {
      question: ' What types of allergies do you treat?',
      answer:
        ' We diagnose and treat various allergies such as dust allergy, pollen allergy, food allergies, skin allergy, pet allergy, sinus allergy, asthma allergies, and seasonal allergic rhinitis.',
    },
    {
      question: 'How do I know if I need to visit an allergy clinic?',
      answer:
        ' Frequent sneezing, runny nose, itchy eyes, skin rashes, frequent inability to breathe and chronic cough or repeated sinus infection may be due to an allergy. An accurate diagnosis can determine the exact culprit so that long-term treatment is effective.',
    },
    {
      question: 'What tests are done to diagnose allergies?',
      answer:
        'Our clinic may suggest doing a skin prick test for allergic reaction, blood tests (IgE test), or a variety of other types of tests that are specifically designed to identify the allergen causing your symptoms.',
    },
    {
      question: 'Is allergy treatment permanent?',
      answer:
        'Although some allergies may never completely disappear, they can be greatly eased by medication and a change in lifestyle. In some cases immunotherapy for long-term control of the problem is also available.',
    },
    {
      question: 'Do you treat children with allergies?',
      answer:
        'Yes, we treat allergies in both children and adults. For pediatric allergies such as food allergy, eczema and asthma, we provide meticulous care tailored to their special needs.',
    },
  ]

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index)
  }
  return (
    <div className='asthmacontent'>
      <Helmet>
        <title>Allergy Clinic In Pitampura | Expert Allergy Treatment</title>
        <meta
          name='description'
          content='Looking for a trusted allergy clinic in Pitampura? Get expert diagnosis and personalized treatment for skin, dust, food & seasonal allergies. Book your consultation today.'
        />
      </Helmet>
      <Header />
      <Whatsapp />
      <div className='asthmamain'>
        <div className='allergyhero'>
          <div className='asthmainner'>
            <div className='heroservice'>
              Service <RiArrowRightSLine /> Allergy
            </div>
            <div className='heroheadline'>
              <h1 className='' style={{ marginBottom: '20px', fontWeight: 'bold' }}>
                Allergy Clinic in Pitampura | Expert Allergy Treatment
              </h1>
              <p className='' style={{ fontFamily: 'inherit' }}>
                Looking for a trusted allergy clinic in Pitampura? Get expert diagnosis and personalized treatment for skin, dust, food & seasonal
                allergies. Book your consultation today.
              </p>
            </div>
            <a href='/appoint'>
              <button className='asthmabtn'>Book Now</button>
            </a>
          </div>
        </div>
        <div className='asthmamid'>
          <div className='asthmapra'>
            <div>
              <h2 style={{ fontSize: '30px', fontWeight: 'bold' }}>Sharva Clinic - Your Trusted Allergy Clinic in Pitampura</h2>
              <p>
                Are your sneezes unstoppable, rash peddles burdening yourself, breath getting more and more difficult or itchy spots come out? Haven’t
                you ever dreamed that the so-called seasonal break is merely part of a more intentional program? Sherveda Clinic can give you an
                accurate diagnosis and personalize the treatment plan to let your allergies be managed effectively. As a reliable allergy clinic in
                Pitampura, we emphasize not only controlling symptoms but identifying the cause.
              </p>
            </div>
            <div>
              <h3 style={{ fontSize: '23px' }}>Comprehensive Allergy Treatment Under One Roof</h3>
              <p>
                Allergies can have a big impact on your daily routine, your quality of sleep, your energy levels and general well being. Each patient
                has a different set of symptoms and treatments will vary accordingly. This is why at Sharva Clinic we begin with a thorough medical
                history and recommend the necessary allergy tests before treatment
              </p>
              <p>Our allergy clinic is able to provide treatment for a wide range of conditions, Including:</p>
              <ul>
                <li>Seasonal allergies (pollen allergy)</li>
                <li>Allergy to dust and Indoor allergies</li>
                <li>Skin allergies and rashes</li>
                <li>Food Allergies</li>
                <li>Allergic Asthma</li>
                <li>Allergic Sinusitis</li>
                <li>Contact Dermatitis</li>
                <li>Chronic Urticaria (itching, red hive patches)</li>
              </ul>
              <p>
                Visit Sharva Clinic, the experienced allergy clinic in Pitampura to manage all of your care from diagnosis through long-term
                treatment. Advanced Allergy Diagnosis
              </p>
              <p>
                An accurate diagnosis is the first step to effective treatment. At Sharva Clinic in treatment of allergy we use modern diagnostic
                methods to spot the specific triggers causing your symptoms. Our assessment may include:
              </p>
              <ul>
                <li>An Read allergy history</li>
                <li>Physician's examination</li>
                <li>Allergy tests (if required)</li>
                <li>Identification of causes and adjustments that can be made in your life</li>
              </ul>
              <p>
                Instead of simply obtaining momentary relief, we have a prophylactic program developed to help reduce the total number in future
                reoccurrences and the severity of symptoms. Personalized Treatment Plans
              </p>
              <p>Allergy treatment cannot be one-size-fits-all. Depending on your condition, we may offer the following:</p>
              <ul>
                <li>The appropriate medication</li>
                <li>Immunotherapy (when indicated)</li>
                <li>Modifications in lifestyle and your surroundings</li>
                <li>Guidance on diets for people who have food allergies</li>
                <li>Protective plans</li>
              </ul>
              <p>
                We draw up plans tailored to fit you on an Individual basis. Our Allergy Clinic in Pitampura is designed to help you breathe more
                easily, live in comfort and regain the confidence of your daily life. Why Sharva Clinic? breathe more easily, live in comfort and
                regain the confidence of your daily life. Why Sharva Clinic?
              </p>
              <p>At Sharva Clinic, patients trust us because we integrate medical knowledge with compassion. </p>
            </div>
            <div>
              <h3 style={{ fontSize: '23px' }}>Why are we different?</h3>
              <ul>
                <li>A patient-centered approach</li>
                <li>Before treatment begins- in-depth evaluation</li>
                <li>A clear explanation of the condition and its triggers</li>
                <li>A long-term plan for managing allergies</li>
                <li>Treatments which are safe and based on evidence</li>
              </ul>
              <p>
                Sharva Clinic provides specialized treatment to families in Pitampura and the surrounding area. Your seasonal allergies, your
                childhood allergies will be addressed here as a part of us. It will not matter what kind of chronic allergic problem you have. Our
                goal is to create solutions in a caring and safe manner that demonstrate successful outcomes. The right clinic and the right care is
                one that can be trusted. At Sharva Clinic, the allergy clinic that residents of Pitampura trust for treatment.
              </p>
            </div>

            <ServiceDoctorInfo
              name='Dr. Gaurav Pandey'
              specialty='Chest and Allergy Specialist'
              education='MD Pulmonary Medicine, Dip. Geriatric Medicine (MAMC), FCC (Cardiology)'
              image={doc_img2}
              blurb='Dr. Gaurav Pandey treats seasonal and chronic allergies at Sharva Clinique with over 9 years of experience in respiratory and allergy care.'
              profileLink='/drgaurav/allergies'
            />

            <div className='faq-container'>
              <h2 className='faq-title'>Frequently Asked Questions – Allergy Clinic in Pitampura</h2>

              <div className='faq-list'>
                {faqData.map((item, index) => (
                  <div key={index} className={`faq-item ${activeIndex === index ? 'active' : ''}`}>
                    <div className='faq-question' onClick={() => toggleFAQ(index)}>
                      <h3>{item.question}</h3>
                      <span className='faq-icon'>{activeIndex === index ? '−' : '+'}</span>
                    </div>

                    <div className='faq-answer-wrapper'>
                      <div className='faq-answer'>
                        <p>{item.answer}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className='asthmareview'>
            <p
              className=''
              style={{
                fontSize: '20px',
                fontWeight: '600',
                color: '#85553D',
                fontFamily: 'inherit',
              }}
            >
              What Our Patients Say
            </p>
            <div className='card1'>
              <p>
                “I had struggled with constant sneezing and itchy eyes for years. After the tests and personalized plan, my symptoms are under
                control. Highly recommend their allergy care.”
              </p>
              <p> — Aman </p>
            </div>
            <div className='card2'>
              <p>
                “Friendly staff, detailed testing, and effective treatment. The difference in my quality of life is huge. I’m so glad I chose this
                clinic for my allergies.”
              </p>
              <p>— Priya </p>
            </div>
            <div className='card3'>
              <p>
                “From the first consultation to follow-up care, the experience was excellent. They helped me understand my triggers and gave practical
                steps that actually work.”
              </p>
              <p> — Sara</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Allergy
